import { createApp } from 'vue'
import options from './HeroGeneralSearch.options'

const el = '.kb-component--hero-general-search'
const DOM = document.querySelector(el)

export default function (Store) {
    if (DOM) {
        var guid = []
        if (DOM.dataset.guid.length && DOM.dataset.guid.startsWith('[')) {
            guid = JSON.parse(DOM.dataset.guid)
        } else {
            guid = [DOM.dataset.guid]
        }
        const primaryTagsDisplayed = DOM.dataset.numberOfPrimaryTags
            ? parseInt(DOM.dataset.numberOfPrimaryTags)
            : 3
        const component = createApp(options, {
            guids: guid,
            primaryTagsDisplayed
        }).use(Store)
        const template = DOM.outerHTML
        options.template = template
        component.mount(el)
    }
}
